import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReportsBreadCrumbs from 'src/pages/Reports/ReportsBreadCrumbs';
import ReportsList from './ReportsList';
import ReportStatusMain from '../../components/reports/reportStatus/ReportStatusMain';
import ReportFactory from '../../components/reports/report-factory/report-factory';
import ReportRegionMain from '../../components/reports/reportRegion/ReportRegionMain';
import ReportCompletedActions from '../../components/reports/report-completed-actions/report-completed-actions';
import { useAppSelector } from 'src/hooks/redux';
import { selectCurrentUser } from 'src/modules/users/selector';
import NoAccess from '../../components/no-access/no-access';

function ReportsMain() {
  const { reportID } = useParams();

  const user = useAppSelector((state) => selectCurrentUser(state));

  const path =
    reportID === '1'
      ? ['Отчет по заводу']
      : reportID === '2'
      ? ['Отчет по региону']
      : reportID === '3'
      ? ['Отчет по выполненным действиям']
      : reportID === '4'
      ? ['Отчет по закрытию периода самооценки']
      : [];

  const [crumbs, setCrumbs] = useState<string[]>(path);

  const handleSetCrumbs = (newCrumb: string) => {
    setCrumbs(() => [newCrumb]);
  };

  useEffect(() => {
    if (!reportID) {
      setCrumbs([]);
    }
  }, [reportID]);

  const isNoAccess = !user.infoVPO.user && !user.infoVPO.admin && !user.infoVPO.zone && !user.infoVPO.adminRegion;

  if (isNoAccess && user.displayName) return <NoAccess />;

  return (
    <>
     {reportID ? (
        <>
          {reportID === '1' && <ReportFactory />}
          {reportID === '2' && <ReportRegionMain/>}
          {reportID === '3' && <ReportCompletedActions />}
          {reportID === '4' && <ReportStatusMain />}
        </>
      ) : (
        <>
          <ReportsBreadCrumbs reportsCrumbs={crumbs} />
          <ReportsList onSetCrumbs={handleSetCrumbs} />
        </>
      )}
    </>
  );
}

export default ReportsMain;
